/**
 * @flow
 * @relayHash dc05780569deec964984cbbb3b104b6b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type PurchaseOrderDetailQueryVariables = {|
  id: string
|};
export type PurchaseOrderDetailQueryResponse = {|
  +purchaseOrder: {|
    +id: string,
    +poNumber: string,
    +vendor: ?{|
      +id: string,
      +vendorNumber: string,
      +name: string,
      +email: ?string,
      +phone: ?string,
      +address: ?string,
      +city: ?string,
      +state: ?string,
      +zipCode: ?string,
      +country: ?string,
    |},
    +status: POStatus,
    +totalAmount: number,
    +expectedDeliveryDate: ?any,
    +receivedAt: ?any,
    +notes: ?string,
    +requestedBy: ?{|
      +id: string,
      +firstName: string,
      +lastName: string,
    |},
    +approvedBy: ?{|
      +id: string,
      +firstName: string,
      +lastName: string,
    |},
    +approvedAt: ?any,
    +createdAt: any,
    +updatedAt: any,
    +lineItems: $ReadOnlyArray<{|
      +id: string,
      +item: {|
        +id: string,
        +itemNumber: string,
        +name: string,
      |},
      +quantity: number,
      +unitPrice: number,
      +totalPrice: number,
      +quantityReceived: ?number,
    |}>,
  |},
  +viewer: ?{|
    +id: string,
    +company: {|
      +id: string,
      +name: ?string,
      +addressLine1: ?string,
      +addressLine2: ?string,
      +addressCity: ?string,
      +addressState: ?string,
      +addressZip: ?string,
      +addressCountry: ?string,
      +phone: ?string,
    |},
  |},
|};
export type PurchaseOrderDetailQuery = {|
  variables: PurchaseOrderDetailQueryVariables,
  response: PurchaseOrderDetailQueryResponse,
|};
*/


/*
query PurchaseOrderDetailQuery(
  $id: ID!
) {
  purchaseOrder(id: $id) {
    id
    poNumber
    vendor {
      id
      vendorNumber
      name
      email
      phone
      address
      city
      state
      zipCode
      country
    }
    status
    totalAmount
    expectedDeliveryDate
    receivedAt
    notes
    requestedBy {
      id
      firstName
      lastName
    }
    approvedBy {
      id
      firstName
      lastName
    }
    approvedAt
    createdAt
    updatedAt
    lineItems {
      id
      item {
        id
        itemNumber
        name
      }
      quantity
      unitPrice
      totalPrice
      quantityReceived
    }
  }
  viewer {
    id
    company {
      id
      name
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      addressCountry
      phone
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v4 = [
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "firstName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "lastName",
    "args": null,
    "storageKey": null
  }
],
v5 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "purchaseOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PurchaseOrder",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "poNumber",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "vendor",
        "storageKey": null,
        "args": null,
        "concreteType": "Vendor",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "vendorNumber",
            "args": null,
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "city",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "state",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "zipCode",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "country",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "status",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "totalAmount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "expectedDeliveryDate",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "receivedAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "notes",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "requestedBy",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "approvedBy",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": (v4/*: any*/)
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "approvedAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "updatedAt",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "lineItems",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrderLine",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": null,
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "itemNumber",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantity",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "unitPrice",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalPrice",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "quantityReceived",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "company",
        "storageKey": null,
        "args": null,
        "concreteType": "Company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine1",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine2",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressCity",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressState",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressZip",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressCountry",
            "args": null,
            "storageKey": null
          },
          (v3/*: any*/)
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PurchaseOrderDetailQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v5/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PurchaseOrderDetailQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v5/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "PurchaseOrderDetailQuery",
    "id": null,
    "text": "query PurchaseOrderDetailQuery(\n  $id: ID!\n) {\n  purchaseOrder(id: $id) {\n    id\n    poNumber\n    vendor {\n      id\n      vendorNumber\n      name\n      email\n      phone\n      address\n      city\n      state\n      zipCode\n      country\n    }\n    status\n    totalAmount\n    expectedDeliveryDate\n    receivedAt\n    notes\n    requestedBy {\n      id\n      firstName\n      lastName\n    }\n    approvedBy {\n      id\n      firstName\n      lastName\n    }\n    approvedAt\n    createdAt\n    updatedAt\n    lineItems {\n      id\n      item {\n        id\n        itemNumber\n        name\n      }\n      quantity\n      unitPrice\n      totalPrice\n      quantityReceived\n    }\n  }\n  viewer {\n    id\n    company {\n      id\n      name\n      addressLine1\n      addressLine2\n      addressCity\n      addressState\n      addressZip\n      addressCountry\n      phone\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd0557e3e1917bd6acbaf7c295a434019';
module.exports = node;
